export default __webpack_public_path__ + "static/media/Mulheres-Unidas-contra-Bolsonaro-2.f466f06e.jpg";